import { getUsageSummaryAPI } from "@/apis/apt-api"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { calcStartDate } from "@/utils/calc-start-date-util"
import { create } from "zustand"

export const summaryStore = create((set) => ({
  stats: {
    percent: 0,
    rank: 0,
    total_count: 0,
    value: 0,
    group_mean: 0
  },
  meta: { unit: "m³" },

  apiGetUsageContext: async ({ dong, ho, resource = "water", group_scope = "apt" } = {}) => {
    const { sido, kapt_code, ended_at: end_date } = aptSearchStore.getState().pickApt

    const start_date = calcStartDate(end_date, "months")
    const { stats, meta } = await getUsageSummaryAPI({
      sido,
      kapt_code,
      dong,
      ho,
      resource,
      start_date,
      end_date,
      group_scope
    })
    set({ stats, meta })
  },

  reset: () =>
    set({
      requestId: 0,
      stats: {
        percent: 0,
        rank: 0,
        value: 0,
        group_mean: 0
      },
      meta: { unit: "m³" },
      color: "pink",
      boxplotSeries: null,
      scatterSeries: null,
      myHouseScatter: null
    })
}))
